<template>
  <v-tooltip bottom :open-delay="openDelay">
    <template v-slot:activator="{ on }">
      <v-icon
        v-on="on"
        v-if="!textDisplay"
        :size="iconSize"
        :color="iconColor"
        :class="className"
        >{{ icon }}</v-icon
      >
      <a v-on="on" v-if="textDisplay">{{ textDisplay }}</a>
    </template>
    <div v-html="text" :id="textId"></div>
  </v-tooltip>
</template>

<script>
export default {
  name: "PopupInfo",
  props: {
    text: {
      type: String,
    },
    textDisplay: {
      type: String,
    },
    icon: {
      type: String,
      default: "far fa-comment-dots",
    },
    iconSize: {
      type: [String, Number],
      default: "11",
    },
    iconColor: {
      type: String,
      default: "",
    },
    className: {
      type: String,
    },
    textId: {
      type: String,
      default: "",
    },
    openDelay: {
      type: [String, Number],
      default: "",
    },
  },
};
</script>

<style scoped>
.adjust-position-1 {
  position: relative;
  top: -1px;
}
</style>
